<template>
  <div>
    <div class="tab">
      <div class="tab__header">
        <div class="tab__header-select">
          <Select2 v-model="currentCollectionId" :options="collectionsFormatted" v-if="collectionsFormatted" :settings="{minimumResultsForSearch: -1}" />
        </div>

        <div class="tab__title h2">Билеты ПДД</div>
      </div>

      <div class="tab__content">
        <router-link
          v-for="ticket of tickets"
          :to="{ path:`/pdd/tickets/${ticket.ticket_number}`, query: { coll: currentCollectionId } }"
          :key="ticket.ticket_number"
          class="ticket"
          :class="getTicketClass(ticket)"
        >
          <div class="ticket__title">{{ ticket.ticket_name }}</div>

          <div v-if="getTicketResult(ticket) && !getTicketResult(ticket).passed" class="ticket__status">
            <div class="correct">{{ getTicketResult(ticket).rightCount }}</div>
            <div class="error">{{ getTicketResult(ticket).done ? getTicketResult(ticket).errorsCount : getTicketResult(ticket).wrongCount}}</div>
          </div>
          <div v-if="getTicketResult(ticket) && getTicketResult(ticket).passed" class="ticket__status">Выполнен</div>
          <div v-if="!getTicketResult(ticket)" class="ticket__status">Не выполнен</div>
        </router-link>
      </div>

      <!--      <a class="link-more">Показать больше</a>-->
    </div>

    <div class="message">
      <div class="message__icon">
        <img src="../../../html/assets/img/icon-exam.svg">
      </div>
      <div class="message__text">40 официальных экзаменационных билетов ПДД РФ на категории A,B,M и C,D с последними изменениями.</div>
    </div>

    <div class="message">
      <div class="message__icon">
        <img src="../../../html/assets/img/icon-time.svg">
      </div>
      <div class="message__text">Время сдачи экзамена - 20 минут.</div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Select2 from 'v-select2-component';

  Vue.component('Select2', Select2);
  export default {
    name: 'Tickets',
    data() {
      return {
        currentCollectionId: null,
      };
    },
    computed: {
      collections() {
        return this.$store.getters.collections;
      },
      tickets() {
        return this.$store.getters.tickets;
      },
      isLoading() {
        return this.$store.getters.collectionsLoaders;
      },
      collectionsFormatted() {
        if (this.collections && this.collections.length > 0) {
          const newArrayOfObj = this.collections.map(({ name: text, ...rest }) => ({ text, ...rest }));
          return newArrayOfObj;
        }

        return null;
      },
    },
    methods: {
      getTicketClass(ticket) {
        const isTicketHasResult = this.getTicketResult(ticket);
        const className = {};

        if (isTicketHasResult && this.getTicketResult(ticket).passed) {
          className['ticket-success'] = true;
        } else if (this.getTicketResult(ticket)) {
          className['ticket-passed'] = true;
        }

        return className;
      },
      loadCollectionTickets(id) {
        this.$store.dispatch('getCollectionTickets', id);
      },
      getTicketResult(ticket) {
        const { ticketResults } = this.$appSettings;
        let ticketInfo = null;

        for (const ticketResult of ticketResults) {
          if (ticketResult.ticketId === parseInt(ticket.ticket_number, 10) && ticketResult.collectionId === parseInt(this.currentCollectionId, 10)) {
            ticketInfo = ticketResult;
            break;
          }
        }

        return ticketInfo;
      },
    },
    created() {
      this.$store.dispatch('getCollections')
        .then(() => {
          const collection = this.collections.filter(el => el.link_id === this.$route.params.cathKey);

          if (this.$route.params.cathKey && collection.length) {
            this.currentCollectionId = collection[0].id;
          } else if (!this.$route.query.coll) {
            if (!localStorage.getItem('collection_id')) {
              this.currentCollectionId = this.collections[0].id;
            } else {
              this.currentCollectionId = localStorage.getItem('collection_id');
            }
          } else {
            this.currentCollectionId = this.$route.query.coll;
          }
        });
    },
    watch: {
      currentCollectionId(id) {
        this.loadCollectionTickets(id);
        localStorage.setItem('collection_id', id);
      },
    },
  };
</script>
